function LocalApi ($http) {
    return {
        getJsonContent: function (fileName) {
            return $http.get(`app/api/${fileName}.json`);
        }
    }
}

angular.module('app')
.factory('LocalApi', LocalApi);